export function loadingReducer(state = {loading: true, requests: 0}, action) {
  switch(action.type) {
    case 'LOADING_DATA_BEGIN':
      return action.payload
    case 'LOADING_DATA_FINISH':
      return action.payload
    default:
      return state
  }
}

export default loadingReducer;



// WEBPACK FOOTER //
// ./src/reducers/loading.js